import sendCouponHistory from '../../service/apis/sendCouponHistory'

import { formatRequestData, download } from '../../plugins/helper'

import { Message } from 'element-ui'

const state = {
  sendCouponInfos: {
    'pageNum': 1,
    'pageSize': 20,
    'dataList': [
    ],
    'total': 20
  },
  sendCouponInfosLoading: true,
  sendCouponRecords: {
    'pageNum': 1,
    'pageSize': 20,
    'total': 10,
    'dataList': [
    ]
  },
  sendCouponRecordsLoading: true,
  comboBoxByType: [],
  couponAmounts: [],
  downLoading: false,
  creatDownloadTaskSuccess: false,
  creatDownloadTaskFail: false
}

// 用于手动初始化数据
const initState = JSON.parse(JSON.stringify(state))

const getters = {}

const actions = {
  async getSendCouponInfos ({ commit, state }, data) {
    try {
      commit('setLoadingTrue', 'sendCouponInfosLoading')
      let requestData = formatRequestData(data)
      let res = await sendCouponHistory.sendCouponInfos(requestData)
      commit('setSendCouponInfos', res.data)
    } catch (e) {
      console.log(e)
    } finally {
      commit('setLoadingFalse', 'sendCouponInfosLoading')
    }
  },
  async getSendCouponRecords ({ commit, state }, data) {
    try {
      commit('setLoadingTrue', 'sendCouponRecordsLoading')
      let requestData = formatRequestData(data)
      let res = await sendCouponHistory.sendCouponRecords(requestData)
      commit('setSendCouponRecords', res.data)
    } catch (e) {
      console.log(e)
    } finally {
      commit('setLoadingFalse', 'sendCouponRecordsLoading')
    }
  },
  async getComboBoxByType ({ commit, state }, data) {
    try {
      let requestData = formatRequestData(data)
      let res = await sendCouponHistory.getComboBoxByType(requestData)
      commit('setComboBoxByType', res.data)
    } catch (e) {
      console.log(e)
    } finally {
    }
  },
  async getCouponAmounts ({ commit, state }, data) {
    try {
      let requestData = formatRequestData(data)
      let res = await sendCouponHistory.getCouponAmounts(requestData)
      commit('setCouponAmounts', res.data)
    } catch (e) {
      console.log(e)
    } finally {
    }
  },
  async downloadFailPhonesFile ({ commit, state }, data) {
    try {
      let requestData = formatRequestData(data)
      // let res = await sendCouponHistory.downloadFailPhonesFile(requestData)
      // downloadFileAxios(res, '发券失败手机号.xls')
      download('/eos/coupon/sendCoupon/downloadFailPhonesFile', requestData, '发券失败手机号.xls')
    } catch (e) {
      console.log(e)
      Message.error('下载失败')
    } finally {
    }
  },
  initState ({ commit }, data) {
    commit('toInitState', data)
  },
  downloadSendCouponInfos ({ commit }, params) {
    commit('setLoadingTrue', 'downLoading')
    sendCouponHistory.downloadSendCouponInfos(formatRequestData(params)).then(res => {
      commit('setLoadingFalse', 'downLoading')
      if (res.status === 0) {
        commit('setLoadingTrue', 'creatDownloadTaskSuccess')
      }
      // console.log(res)
    }).catch(() => {
      commit('setLoadingFalse', 'downLoading')
      commit('setLoadingTrue', 'creatDownloadTaskFail')
    })
  }
}

const mutations = {
  setSendCouponInfos (state, couponInfos) {
    state.sendCouponInfos = couponInfos
  },
  setSendCouponRecords (state, couponRecords) {
    state.sendCouponRecords = couponRecords
  },
  setComboBoxByType (state, data) {
    state.comboBoxByType = data
  },
  setCouponAmounts (state, data) {
    state.couponAmounts = data
  },
  setLoadingTrue (state, stateKey) {
    state[stateKey] = true
  },
  setLoadingFalse (state, stateKey) {
    state[stateKey] = false
  },
  toInitState (state, stateKey) {
    state[stateKey] = initState[stateKey]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
